
import {
  uses,
  serviceFeatures,
  steps,
  statsData,
  popularServices,
  questions,
  customers,
} from "~/data/cloudMigration";
import Uses from "~/components/cloud-migration/Uses.vue";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  components: {
    Uses,
    Modal,
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "مهاجرت ابری آبالون | سریع، امن، سازگار و مقیاس‌پذیر",
      meta: [
        {
          name: "description",
          content:
            "مهاجرت ابری امن، بهینه و سریع از زیرساخت سنتی سازمان شما | متناسب با معماری فعلی ‌|‌ با حداقل ریسک‌ و اختلال در سرویس‌ها | مهاجرت ابری با آبالون",
        },
        {
          name: "keywords",
          content: "مهاجرت ابری, استقرار ابری",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/cloud-migration",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "مهاجرت ابری آبالون | سریع، امن، سازگار و مقیاس‌پذیر",
        },
        {
          property: "og:description",
          content:
            "مهاجرت ابری امن، بهینه و سریع از زیرساخت سنتی سازمان شما | متناسب با معماری فعلی ‌|‌ با حداقل ریسک‌ و اختلال در سرویس‌ها | مهاجرت ابری با آبالون",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/cloud-migration",
        },
        {
          name: "twitter:title",
          title: "مهاجرت ابری آبالون | سریع، امن، سازگار و مقیاس‌پذیر",
        },
        {
          name: "twitter:description",
          content:
            "مهاجرت ابری امن، بهینه و سریع از زیرساخت سنتی سازمان شما | متناسب با معماری فعلی ‌|‌ با حداقل ریسک‌ و اختلال در سرویس‌ها | مهاجرت ابری با آبالون",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/cloud-migration",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "آیا برای مهاجرت ابری نیاز به بازنویسی کامل نرم‌افزارهای فعلی وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "عمده مدل‌های مهاجرت نیازی به بازنویسی کامل نرم‌افزارها را ندارد و بسته به مدل مهاجرت انتخابی، می‌توان دیتاسنتر با معماری سنتی یا ابری را بدون تغییر در کد یا معماری به زیرساخت ابری منتقل کرد. در مواردی که نیاز به بهینه‌سازی یا بازطراحی (Refactor) وجود دارد، تیم فنی آبالون مسیر مناسب را طراحی و اجرا می‌کند.",
                },
              },
              {
                "@type": "Question",
                name: "در طول فرآیند مهاجرت، چه تضمینی برای پایداری سرویس‌های جاری وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "مهاجرت ابری در آبالون به‌صورت مرحله‌ای و تحت نظارت کامل انجام می‌شود. با پایش مداوم عملکرد در هر فاز، اختلال در سرویس‌های حیاتی به حداقل می‌رسد و تداوم کسب‌وکار هم‌زمان با استقرار ابری تضمین می‌شود.",
                },
              },
              {
                "@type": "Question",
                name: "آیا امکان استقرار ابری تنها بخشی از زیرساخت سازمان وجود دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله. راهکار آبالون از مدل‌های مختلف مهاجرت، از جمله مهاجرت ترکیبی (Hybrid) یا مهاجرت تدریجی سرویس‌ها و پایگاه‌های داده پشتیبانی می‌کند. این انعطاف‌پذیری به سازمان اجازه می‌دهد مطابق با الزامات خود، برنامه مهاجرت را تجربه کند.",
                },
              },
              {
                "@type": "Question",
                name: "چه سازمان‌هایی بیشترین بهره را از راهکار مهاجرت ابری آبالون می‌برند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سازمان‌هایی که با چالش‌هایی مانند هزینه‌های بالای نگه‌داری زیرساخت سنتی، نیاز به مقیاس‌پذیری سریع، الزامات امنیتی و یا ضرورت بازیابی در بحران مواجه هستند، می‌توانند با مهاجرت به ابر، بهره‌وری و انعطاف‌پذیری خود را به‌طور قابل‌توجهی افزایش دهند.",
                },
              },
            ],
          },
        },
      ],
    };
  },
  data() {
    return {
      uses,
      serviceFeatures,
      statsData,
      steps,
      popularServices,
      questions,
      customers,
      title: "مهاجرت ابری آبالون | سریع، امن، سازگار و مقیاس‌پذیر",
      FormTitle: "ثبت درخواست ارتباط با واحد فروش",
      activeSection: "",
      tab: 0,
      solotionTab: 0,
      showmore: false,
    };
  },
  mounted() {},
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
    showMore() {
      this.showmore = true;
    },
  },
};
